<div *ngIf="isVisible" class="report-progress-block">
  <div class="progress-dots">
    <span class="dot dot-1"></span>
    <span class="dot dot-2"></span>
    <span class="dot dot-3"></span>
  </div>
  <p class="report-progress-text">{{ progressText }}</p>
  <ion-button
    class="page-button cancel-report-btn"
    color="danger"
    (click)="onCancel()">
    {{"SHARED.Cancel" | translate}}
  </ion-button>
</div>
